/* istanbul ignore next */
import Vue from "vue";
import { createRouter } from "./router";
import store from "./store";
import ErrorPlugin from "./plugins/errorPlugin";
const router = process.env.VUE_APP_USAGE === "application" ? createRouter("history") : createRouter("abstract");
const REQUEST_ABORTED = "request aborted";
const ROUTE_REDIRECT_ERROR = "Error: Navigation aborted from";
const globalErrorHandler = ((router, store) => (error, vm, info) => {
    if (error === REQUEST_ABORTED) {
        return;
    }
    if (error instanceof DOMException) {
        // ignore un-handled custom element defined error.
        return;
    }
    if (`${error}`.includes(ROUTE_REDIRECT_ERROR)) {
        return;
    }
    console.warn(error);
    /* TO DO: For later implemantation */
    // const notification = {
    //     size: "medium",
    //     variation: "error",
    //     title: "",
    //     persistent: false,
    //     text: error,
    //     duration: 10000
    // };
    // store.dispatch("notifications/showNotification", notification);
})(router, store);

Vue.use(ErrorPlugin, {
    errorHandler: globalErrorHandler
});

window.onunhandledrejection = e => {
    globalErrorHandler(e.reason, null, null);
    if (e.reason instanceof DOMException) {
        e.preventDefault();
    }
};
